<template>
    <div class="pub-container">
        <div class="pub-status">
            {{ pubMsg }}
        </div>
        <div class="pub">
            <div class="pub__visuel">
                <img :src="pubImageSrc" alt="">
            </div>
            <div class="pub__content">
                <div class="pub__date">{{pubDate}}</div>
                <div class="pub__title">{{pubTitle}}</div>
                <div class="pub__offer">{{pubOffer}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            "pubMsg"
        ],
        computed: {
            pubDate() { return this.$store.state.ad.date },
            pubTitle() { return this.$store.state.ad.title },
            pubOffer() { return this.$store.state.ad.offer },
            pubImageSrc() { return this.$store.state.ad.imgSrc }
        }
    }
</script>


// WEBPACK FOOTER //
// ad.vue?40ddeb9e